import { PlateBuilderActions, PlateBuilderPayload } from './plate-builder.action';
import { PlateBuilder, Configuration, PlateBuilderReturn, PlateCalc, TroughModel, PlateElementsBuilder } from 'franke-trough-dependencies';
import { FSA } from 'flux-standard-action';

export interface PlateBuilderState {
  components: PlateBuilderReturn;
  calc: PlateCalc;
  conf: Configuration;
  trough: TroughModel;
  elementsBuilder: PlateElementsBuilder;
  populateWithConfOverrides: (confOverrides: any) => PlateBuilderReturn;
  updatedAt: number;
}

export const plateBuilderReducer = (state: (PlateBuilderState | null) = null, action: FSA<PlateBuilderActions, PlateBuilderPayload>): (PlateBuilderState | null) => {
  switch (action.type) {
    case PlateBuilderActions.Assign:
      if (!action.payload) { return state }
      const plateBuilder = new PlateBuilder(new Configuration(action.payload.configuration), action.payload.trough);

      return {
        components: plateBuilder.components,
        calc: plateBuilder.calc,
        conf: plateBuilder.conf,
        trough: plateBuilder.trough,
        elementsBuilder: plateBuilder.elementsBuilder,
        populateWithConfOverrides: plateBuilder.populateWithConfOverrides,
        updatedAt: Date.now(),
      };
    case PlateBuilderActions.Clear:
      return null;
    default:
      return state;
  }
};